import { toString } from '../helpers/date'
import snapshotParser from '../helpers/snapshotparser'
import { db } from './firebase'
import templateEmail from './templateEmail'

export const getConfig = async () => {
  const result = await db.doc('config/main').get()
  const { appointmentInterval, appointmentInit, appointmentEnd, saturdayInit, saturdayEnd } = snapshotParser(result)
  return { interval: appointmentInterval, init: appointmentInit.toDate(), end: appointmentEnd.toDate(), saturdayInit: saturdayInit.toDate(), saturdayEnd: saturdayEnd.toDate() }
}

/**
 * @param {string} stringDate
 */
export const onListChange = (handler, stringDate) => {
  const unsubscribe = db.collection('quotes').where('stringDate', '==', stringDate).onSnapshot(snapshot => {
    var list = snapshotParser(snapshot)
    list = list.map(item => {
      const currentItem = { ...item }
      if (currentItem.date) currentItem.date = currentItem.date.toDate()
      if (currentItem.operationDate) currentItem.operationDate = currentItem.operationDate.toDate()
      return currentItem
    })
    handler(list)
  })
  return unsubscribe
}

export const save = async data => {
  try {
    const appointmentsFetcher = getListPaginated(9999, { isFinished: true, notPast: true })
    const appointments = await appointmentsFetcher()
    for (const appointment of appointments) {
      console.log(appointment.date === data.date)
      console.log('dates', appointment.date, data.date)
      if (appointment.date === data.date) {
        window.alert('Error porfavor intentalo de nuevo')
        window.location.reload()
        throw new Error('Error porfavor intentalo de nuevo')
      }
    }

    const { id } = await db.collection('quotes').add({
      ...data,
      stringDate: toString(data.date),
      isPaid: false,
      isFinished: false,
      isExternalFormComplete: false,
      operationDate: new Date()
    })
    return id
  } catch (error) {
    console.log('saveError', error)
    return false
  }
}

export const deleteOne = async id => {
  try {
    await db.doc(`quotes/${id}`).delete()
    return true
  } catch (error) {
    return false
  }
}

export const update = async (id, data) => {
  try {
    console.log('uodatingdata.date', data.date, toString(data.date))
    if (data.date) data.stringDate = toString(data.date)
    await db.doc(`quotes/${id}`).update(data)
    return id
  } catch (error) {
    console.log('handleUpdateError', error)
    return false
  }
}

export const getSingle = async id => {
  try {
    var data = await db.doc(`quotes/${id}`).get()
    data = snapshotParser(data)
    if (data.date) data.date = data.date.toDate()
    if (data.operationDate) data.operationDate = data.operationDate.toDate()
    return data
  } catch (error) {
    console.log('getSingleError', error)
    return false
  }
}

export const updateConfig = async ({ init, end, interval, saturdayEnd, saturdayInit }) => {
  try {
    await db.doc('config/main').update({ appointmentInit: init, appointmentEnd: end, appointmentInterval: parseInt(interval), saturdayEnd, saturdayInit })
    return true
  } catch (error) {
    console.log('ErrorUpdateCOnfig', error)
    return false
  }
}

export const updateDisableDates = async dates => {
  try {
    await db.doc('config/main').update({ disableDays: dates })
    return true
  } catch (error) {
    console.log('ErrorUpdateDIsableDates', error)
    return false
  }
}

export const getDisabledDates = async () => {
  try {
    let data = await db.doc('config/main').get()
    data = snapshotParser(data)
    return data.disableDays.map(d => d.toDate()) || []
  } catch (error) {
    console.log('ErrorgetDisabledDates', error)
    return []
  }
}

export const getListPaginated = (limit = 10, filters = {}) => {
  const dateToStart = new Date()
  dateToStart.setHours(0)
  dateToStart.setMinutes(0)

  var last = null
  var finished = false

  return async () => {
    if (finished) return []
    try {
      let query = db.collection('quotes').orderBy('date', 'asc')
      if (filters.isFinished) query = query.where('isFinished', '==', true)
      if (filters.notPast) query = query.where('date', '>', dateToStart)

      if (last) query = query.startAfter(last)
      if (limit) query = query.limit(limit)

      if (process.env.NODE_ENV === 'development') await new Promise(resolve => setTimeout(resolve, 500))

      const snapshot = await query.get()
      last = snapshot.docs[snapshot.docs.length - 1]
      if (snapshot.docs.length !== limit) finished = true
      let data = snapshotParser(snapshot)
      data = data.map(item => {
        const currentItem = { ...item }
        currentItem.date = currentItem.date.toDate()
        currentItem.operationDate = currentItem.operationDate.toDate()
        return currentItem
      })
      return data
    } catch (error) {
      console.log('__error__', error)
      return []
    }
  }
}

// name
// birtdate
// phone
// email
// date
export const sendMail = async (data) => {
  const url = `${window.location.protocol}//${window.location.host}/appointment#indications`
  const template = templateEmail({ ...data, url })
  await db.collection('email').add({
    to: data.email,
    message: {
      subject: 'Confirmación de cita',
      html: template
    }
  })
}

window.sendMail = sendMail
